<template>
  <div v-if="$whitelabel.short === 'radiogutscheine'" class="radiogutscheine-header-content">

    <div class="navbar-item">
      <a href="https://whatsapp.com/channel/0029VbD9ZzJGpLHHvpWpQP2w" target="_blank" rel="noopener noreferrer">
        <img src="https://assets.urlaubsgutschein.kaufen/whitelabel/radiogutscheine/whatsapp-inline-green.svg"
          title="WhatsApp" width="110" class="is-block">
      </a>
    </div>

    <div class="navbar-item">
      <a href="https://radiogutscheine.de/gutscheine/aktionen/weniger-zahlen_320?newsletter=1" target="_blank"
        rel="noopener noreferrer">
        Newsletter
      </a>
    </div>
  </div>
</template>

<script>
export default {
  name: 'RadiogutscheineHeaderContent',
}
</script>

<style lang="scss" scoped>
.radiogutscheine-header-content {
  display: contents;
}
</style>
